const initialState = {
    doctorType: 1, // 1->omumi 2->motekhases 3->foghe takhasos
    visitPrice: '357,000',
    visitPriceAfterDiscount: '357,000',
    description: '',
    discountCode: '',
    activeDiscount: false,
    discountAmount: '',
};
const visitReq = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGES_VISIT_REQUEST':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default visitReq;
